import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import ModalHeaderLayout from "../../../layouts/ModalHeaderLayout";
import axios from "axios";
import { apiUrl } from "../../../config";
import UserContext from "../../../Context/UserContext";
import { useTranslation } from "react-i18next";

const MalzemeKoduModal = ({
  modalOpen,
  setModalOpen,
  selectedRow,
  rule,
  setRefreshPage,
  refreshPage,
  getColor,
  bodyMaterialType
}) => {
  const { t } = useTranslation();
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_SECRET_KEY;

  const [formData, setFormData] = useState({
    malzeme_kodu: "",
    tanim: "",
    min_inventory_periodically: "",
    put_inventory_before_demand: "",
    production_rate_according_demand: "",
    par_obj_func_stop_exceeding_demand: "",
    critical: "",
    end_min_inventory: null,
    end_max_inventory: null,
    hour_delayed: "",
    produce_close_demand: "",
    body_color: "",
    body_material_type: "",
    is_service: "",
  });


  useEffect(() => {
    if (modalOpen) {
      if (selectedRow && rule === "changeOrder") {
        setFormData({
          malzeme_kodu: selectedRow.malzeme_kodu || "",
          tanim: selectedRow.tanim || "",
          min_inventory_periodically: selectedRow.min_inventory_periodically || "",
          put_inventory_before_demand: selectedRow.put_inventory_before_demand == 0 ? 0 : (selectedRow.put_inventory_before_demand || ""),
          production_rate_according_demand: selectedRow.production_rate_according_demand || "",
          par_obj_func_stop_exceeding_demand: selectedRow.par_obj_func_stop_exceeding_demand || "",
          critical: String(selectedRow.critical) || "",
          end_min_inventory: selectedRow.end_min_inventory || null,
          end_max_inventory: selectedRow.end_max_inventory || null,
          hour_delayed: selectedRow.hour_delayed || "",
          produce_close_demand: String(selectedRow.produce_close_demand) || "",
          body_color: selectedRow.body_colorid || "",
          body_material_type: selectedRow.body_material_typeid || "",
          is_service: String(selectedRow.is_service) || "",
        });
      } else if (rule === "newOrder") {
        setFormData({
          malzeme_kodu: "",
          tanim: "",
          min_inventory_periodically: "",
          put_inventory_before_demand: "",
          production_rate_according_demand: "",
          par_obj_func_stop_exceeding_demand: "",
          critical: "",
          end_min_inventory: null,
          end_max_inventory: null,
          hour_delayed: "",
          produce_close_demand: "",
          body_color: "",
          body_material_type: "",
          is_service: "",
        });
      }
    }
  }, [selectedRow, modalOpen, rule]);
  const { user } = useContext(UserContext)


  // ZORUNLU ALAN UYARILARI İÇİN ERROR STATE VE DOĞRULAMA FONKSİYONU
  const [errors, setErrors] = useState({});
  const isEmptyValue = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    return false;
  };

  useEffect(() => {
    if (modalOpen) {
      setErrors({});
    }
  }, [modalOpen, rule, selectedRow]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const errs = {};
    const f = formData;

    if (isEmptyValue(f.malzeme_kodu)) errs.malzeme_kodu = `${t("constraints.materialCode")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.tanim)) errs.tanim = `${t("constraints.description")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.put_inventory_before_demand)) errs.put_inventory_before_demand = `${t("constraints.putInventoryBeforeDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.production_rate_according_demand)) errs.production_rate_according_demand = `${t("constraints.productionRateAccordingDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.critical)) errs.critical = `${t("constraints.critical")} ${t("constraints.isRequired")}`;

    if (f.critical === "false" && isEmptyValue(f.min_inventory_periodically)) {
      errs.min_inventory_periodically = `${t("constraints.minInventoryPeriodically")} ${t("constraints.isRequired")}`;
    }
    if (f.critical === "true") {
      if (isEmptyValue(f.end_min_inventory)) errs.end_min_inventory = `${t("constraints.endMinInventory")} ${t("constraints.isRequired")}`;
      if (isEmptyValue(f.end_max_inventory)) errs.end_max_inventory = `${t("constraints.endMaxInventory")} ${t("constraints.isRequired")}`;
    }

    if (isEmptyValue(f.hour_delayed)) errs.hour_delayed = `${t("constraints.hourDelayed")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.produce_close_demand)) errs.produce_close_demand = `${t("constraints.produceCloseDemand")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.is_service)) errs.is_service = `${t("constraints.isService")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.body_color)) errs.body_color = `${t("constraints.bodyColor")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.body_material_type)) errs.body_material_type = `${t("constraints.bodyType")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(f.par_obj_func_stop_exceeding_demand)) {
      errs.par_obj_func_stop_exceeding_demand = `${t("constraints.parObjFuncStopExceedingDemand")} ${t("constraints.isRequired")}`;
    }

    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validateForm();
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    const requestMethod = rule === "changeOrder" ? axios.put : axios.post;
    let requestData;
    if (rule === "changeOrder") {
      requestData = { ...formData, id: selectedRow.id };
    } else {
      requestData = formData;
    }

    requestMethod(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addBodyMaterial`,
      requestData, {
      headers: {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`
      },
      params: {
        username: user?.accountDetail?.name
      }
    })
      .then(res => {
        if (res.status === 200) {
          setFormData({
            malzeme_kodu: selectedRow.malzeme_kodu || "",
            tanim: selectedRow.tanim || "",
            min_inventory_periodically: selectedRow.min_inventory_periodically || "",
            put_inventory_before_demand: selectedRow?.put_inventory_before_demand || "55",
            production_rate_according_demand: selectedRow.production_rate_according_demand || "",
            par_obj_func_stop_exceeding_demand: selectedRow.par_obj_func_stop_exceeding_demand || "",
            critical: selectedRow.critical || "",
            end_min_inventory: selectedRow.end_min_inventory || null,
            end_max_inventory: selectedRow.end_max_inventory || null,
            hour_delayed: selectedRow.hour_delayed || "",
            produce_close_demand: selectedRow.produce_close_demand || "",
            body_color: selectedRow.body_colorid,
            body_material_type: selectedRow.body_material_typeid,
            is_service: selectedRow.is_service || "",
          });
          setErrors({});
          setModalOpen(false);
          setRefreshPage(!refreshPage);
        }
      })
      .catch(err => console.log(err));
  }

  return (
    <Modal
      title=<ModalHeaderLayout title={rule === "changeOrder" ? t("constraints.changeMaterialCode") : t("constraints.addMaterial")} />
      open={modalOpen}
      footer={null}
      onOk={() => setModalOpen(false)}
      onCancel={() => {
        setModalOpen(false);
        setErrors({});
      }}
      centered
      className="min-w-max mb-40"
    >
      <form className='bg-surface pl-10 pr-10 pb-10 rounded-2xl shadow-2xl' onSubmit={handleSubmit}>

        <div className='grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:grid-cols-4 gap-7'>
          <div>
            <label htmlFor="malzeme_kodu">{t("constraints.materialCode")}</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="malzeme_kodu" value={formData.malzeme_kodu} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.malzeme_kodu && <div className="text-red-600 text-xs mt-1">{errors.malzeme_kodu}</div>}
          </div>
          <div>
            <label htmlFor="tanim ">{t("constraints.description")}</label>
            <input onChange={(e) => handleChange(e)} type="text" name="tanim" value={formData.tanim} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.tanim && <div className="text-red-600 text-xs mt-1">{errors.tanim}</div>}
          </div>
          {
            formData.critical === "false" ?
              <div>
                <label htmlFor="min_inventory_periodically">{t("constraints.minInventoryPeriodically")}:</label>
                <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="min_inventory_periodically" value={formData.min_inventory_periodically} className="bg-gray-200 rounded h-8 block w-full mt-1" />
                {errors.min_inventory_periodically && <div className="text-red-600 text-xs mt-1">{errors.min_inventory_periodically}</div>}
              </div>
              : null
          }
          <div>
            <label htmlFor="fname1">{t("constraints.putInventoryBeforeDemand")}:</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="put_inventory_before_demand" value={formData.put_inventory_before_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.put_inventory_before_demand && <div className="text-red-600 text-xs mt-1">{errors.put_inventory_before_demand}</div>}
          </div>
          <div>
            <label htmlFor="fname1">{t("constraints.productionRateAccordingDemand")}:</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" step="any" min="0" name="production_rate_according_demand" value={formData.production_rate_according_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.production_rate_according_demand && <div className="text-red-600 text-xs mt-1">{errors.production_rate_according_demand}</div>}
          </div>
          <div>
            <label htmlFor="critical">{t("constraints.critical")}</label>
            <select onChange={(e) => handleChange(e)} name="critical" value={formData.critical} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              <option value="true">{t("constraints.yes")}</option>
              <option value="false">{t("constraints.no")}</option>
            </select>
            {errors.critical && <div className="text-red-600 text-xs mt-1">{errors.critical}</div>}
          </div>
          {
            formData.critical === "true" ?
              <>
                <div>
                  <label htmlFor="fname1">{t("constraints.endMinInventory")} :</label>
                  <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="end_min_inventory" value={formData.end_min_inventory} className="bg-gray-200 rounded h-8 block w-full mt-1" />
                  {errors.end_min_inventory && <div className="text-red-600 text-xs mt-1">{errors.end_min_inventory}</div>}
                </div>
                <div>
                  <label htmlFor="fname1">{t("constraints.endMaxInventory")} :</label>
                  <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="end_max_inventory" value={formData.end_max_inventory} className="bg-gray-200 rounded h-8 block w-full mt-1" />
                  {errors.end_max_inventory && <div className="text-red-600 text-xs mt-1">{errors.end_max_inventory}</div>}
                </div>
              </>
              : null
          }

          <div>
            <label htmlFor="fname1">{t("constraints.hourDelayed")} :</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="hour_delayed" value={formData.hour_delayed} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.hour_delayed && <div className="text-red-600 text-xs mt-1">{errors.hour_delayed}</div>}
          </div>
          <div>
            <label htmlFor="produce_close_demand">{t("constraints.produceCloseDemand")}</label>
            <select onChange={(e) => handleChange(e)} name="produce_close_demand" value={formData.produce_close_demand} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              <option value="true">{t("constraints.yes")}</option>
              <option value="false">{t("constraints.no")}</option>
            </select>
            {errors.produce_close_demand && <div className="text-red-600 text-xs mt-1">{errors.produce_close_demand}</div>}
          </div>
          <div>
            <label htmlFor="is_service">{t("constraints.isService")}</label>
            <select onChange={(e) => handleChange(e)} name="is_service" value={formData.is_service} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              <option value="true">{t("constraints.yes")}</option>
              <option value="false">{t("constraints.no")}</option>
            </select>
            {errors.is_service && <div className="text-red-600 text-xs mt-1">{errors.is_service}</div>}
          </div>

          <div>
            <label htmlFor="body_color">{t("constraints.bodyColor")} :</label>
            <select onChange={(e) => handleChange(e)} name="body_color" value={formData.body_color} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              {
                getColor && getColor.map(item => {
                  return <option value={item.id}>{item.description}</option>
                })
              }
            </select>
            {errors.body_color && <div className="text-red-600 text-xs mt-1">{errors.body_color}</div>}
          </div>

          <div>
            <label htmlFor="body_material_type">{t("constraints.bodyType")} :</label>
            <select onChange={(e) => handleChange(e)} name="body_material_type" value={formData.body_material_type} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              {
                bodyMaterialType && bodyMaterialType.map(item => {
                  return <option value={item.id}>{item.description}</option>
                })
              }
            </select>
            {errors.body_material_type && <div className="text-red-600 text-xs mt-1">{errors.body_material_type}</div>}
          </div>
          <div>
            <label htmlFor="par_obj_func_stop_exceeding_demand">{t("constraints.parObjFuncStopExceedingDemand")} :</label>
            <input onChange={(e) => handleChange(e)} onWheel={(e) => e.target.blur()} type="number" min="0" name="par_obj_func_stop_exceeding_demand" value={formData.par_obj_func_stop_exceeding_demand} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.par_obj_func_stop_exceeding_demand && <div className="text-red-600 text-xs mt-1">{errors.par_obj_func_stop_exceeding_demand}</div>}
          </div>
        </div>
        <div>
          <button type="submit" className="bg-smartopt hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 w-full">{t("singularParameters.submit")}</button>
        </div>
      </form>
    </Modal>
  );
};

export default MalzemeKoduModal;

